var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:( _obj = {}, _obj[_vm.type] = true, _obj )},_vm._l((_vm.cardGroup),function(card){
var _obj;
return _c('li',{key:card.id,class:[( _obj = {}, _obj[card.size] = true, _obj ), _vm.cardStyle]},[_c('card',_vm._b({attrs:{"type":_vm.cardStyle}},'card',card,false))],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }